/**
 * Initialize lightGallery on product galleries
 */
document.addEventListener('DOMContentLoaded', function() {
  // Find all product galleries
  const galleries = document.querySelectorAll('.lg-gallery');
  
  galleries.forEach(initLightGallery);
  
  // Make refreshLightGallery available globally
  window.refreshLightGallery = function(gallery) {
    if (gallery.lgInstance) {
      gallery.lgInstance.destroy(true);
      initLightGallery(gallery);
    }
  };
});

/**
 * Initialize lightGallery on a specific gallery element
 */
function initLightGallery(gallery) {
  if (!gallery) return;
  
  // Find all visible image items in this gallery
  const productImages = gallery.querySelectorAll('.product__media-item:not(.hidden) .product-image-lightbox-trigger');
  if (!productImages.length) return;

  // Convert NodeList to Array and prepare lightGallery dynamic elements
  const dynamicElements = Array.from(productImages).map((image) => {
    return {
      src: image.getAttribute('data-lg-src'),
      thumb: image.querySelector('img').src,
      subHtml: image.getAttribute('data-lg-alt'),
      width: image.getAttribute('data-lg-width'),
      height: image.getAttribute('data-lg-height')
    };
  });

  // Initialize lightGallery
  const lgInstance = lightGallery(gallery, {
    dynamic: true,
    dynamicEl: dynamicElements,
    closable: true,
    closeOnTap: true,
    showMaximizeIcon: false,
    zoomFromOrigin: true,
    plugins: [lgZoom, lgThumbnail],
    download: false,
    mode: 'lg-fade',
    speed: 500,
    mousewheel: true,
    thumbnail: true,
    thumbWidth: 80,
    thumbHeight: 80,
    alignThumbnails: 'left',
    allowMediaOverlap: true,
    getCaptionFromTitleOrAlt: false,
    addClass: 'product-lightgallery',
    hideScrollbar: true,
    mobileSettings: {
      controls: false,
      showCloseIcon: true,
      download: false,
      thumbnail: true
    }
  });
  
  // Store the instance for later reference
  gallery.lgInstance = lgInstance;
  
  // Attach click listeners to visible product images
  productImages.forEach((image) => {
    image.style.cursor = 'zoom-in';
  
    // Helper function to open gallery
    const openGallery = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Open gallery at correct index
      const clickedSrc = image.getAttribute('data-lg-src');
      const currentIndex = dynamicElements.findIndex(el => el.src === clickedSrc);
      gallery.lgInstance.openGallery(currentIndex >= 0 ? currentIndex : 0);
    };
    
    // Variables to track touch position
    let touchStartX = 0;
    let touchStartY = 0;
    
    // Add touch events for mobile Safari
    image.addEventListener('touchstart', (e) => {
      // Record starting position
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      // Don't prevent default here to allow slideshow swipes
    }, { passive: true });
    
    image.addEventListener('touchend', (e) => {
      if (e.changedTouches.length > 0) {
        // Calculate distance moved
        const touchEndX = e.changedTouches[0].clientX;
        const touchEndY = e.changedTouches[0].clientY;
        const distanceX = Math.abs(touchEndX - touchStartX);
        const distanceY = Math.abs(touchEndY - touchStartY);
        
        // Only open gallery if it was a tap (minimal movement)
        // Adjust the threshold (10px) based on testing
        if (distanceX < 10 && distanceY < 10) {
          e.preventDefault();
          openGallery(e);
        }
      }
    }, { passive: false });
    
    // Keep click event for desktop browsers
    image.addEventListener('click', openGallery);  
  });
}
